<template>
  <div v-if="isLocationViewActiveLocal">
    <div class="vx-row">
      <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 277px">
        <vx-input-group>
          <template slot="prepend">
            <div class="prepend-text glow-effect_bg-color__blend bg-color">
              <span><feather-icon class="pt-1" icon="MapPinIcon" svg-classes="stroke-current"></feather-icon></span>
            </div>
          </template>

          <vs-button
            :disabled="true"
            size="large"
            class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
            type="filled"
            color="">
            Current Location(s):
          </vs-button>
        </vx-input-group>
      </vx-card>
    </div>
    <div class="vx-row" id="current-location-row">
      <div class="vx-col w-full">
        <vx-card class="mb-3 glow-effect_dark card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="w-full button-text__left-align button__fully-opaque bg-color"
              style="border-radius:0 7px 7px 0"
              type="filled"
              color="">
              {{ selectedData ? selectedData.selectedLanguage : "" }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
    <div class="vx-row" id="current-location-row">
      <div class="vx-col w-full">
        <vx-card class="mb-3 glow-effect_dark card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="w-full button-text__left-align button__fully-opaque bg-color"
              style="border-radius:0 7px 7px 0"
              type="filled"
              color="">
              {{ 'selectedGrade' in selectedData ? selectedData.selectedGrade.name : "" }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
    <div class="vx-row" id="current-location-row">
      <div class="vx-col w-full">
        <vx-card class="mb-3 glow-effect_dark card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="w-full button-text__left-align button__fully-opaque bg-color"
              style="border-radius:0 7px 7px 0"
              type="filled"
              color="">
              {{ 'selectedSubject' in selectedData ? selectedData.selectedSubject.name : "" }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
    <div class="vx-row" id="current-location-row">
      <div class="vx-col w-full">
        <vx-card class="mb-3 glow-effect_dark card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="CodesandboxIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="w-full button-text__left-align button__fully-opaque bg-color"
              style="border-radius:0 7px 7px 0"
              type="filled"
              color="">
              {{ 'selectedModule' in selectedData ? selectedData.selectedModule.name : "" }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
    <div class="vx-row" id="current-location-row">
      <div class="vx-col w-full">
        <vx-card class="mb-3 glow-effect_dark card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="DiscIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="w-full button-text__left-align button__fully-opaque bg-color"
              style="border-radius:0 7px 7px 0"
              type="filled"
              color="">
              {{ 'selectedTopic' in selectedData ? selectedData.selectedTopic.name : "" }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>

    <div class="mt-3" v-for="(_location, index) in locations" :key="index">
      <div class="vx-row show-remove-location-on_hover">
        <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 277px">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text bg-color" style="color: gold;">
                <span><feather-icon class="pt-1" icon="StarIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend sub-header_button-lookalike text__school-tertiary-color bg-color"
              type="filled"
              color="">
              {{ `Additional Location ${index + 1}` }}
            </vs-button>
          </vx-input-group>
        </vx-card>
        <vs-button id="removelocationbtn" size="small" color="danger" type="flat" icon-pack="feather" icon="icon-x" icon-after @click="locations.splice(index,1)">Remove</vs-button>
      </div>
      <div class="vx-row" id="added-location-rows">
        <div class="vx-col w-full">
          <vx-card class="mb-3 glow-effect_dark card__no-padding bg-color">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                :disabled="true"
                size="large"
                class="w-full button-text__left-align button__fully-opaque bg-color"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="">
                {{ _location.selectedLanguage }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
      </div>
      <div class="vx-row" id="added-location-rows">
        <div class="vx-col w-full">
          <vx-card class="mb-3 glow-effect_dark card__no-padding bg-color">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                :disabled="true"
                size="large"
                class="w-full button-text__left-align button__fully-opaque bg-color"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="">
                {{ _location.selectedGrade.name }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
      </div>
      <div class="vx-row" id="added-location-rows">
        <div class="vx-col w-full">
          <vx-card class="mb-3 glow-effect_dark card__no-padding bg-color">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                :disabled="true"
                size="large"
                class="w-full button-text__left-align button__fully-opaque bg-color"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="">
                {{ _location.selectedSubject.name }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
      </div>
      <div class="vx-row" id="added-location-rows">
        <div class="vx-col w-full">
          <vx-card class="mb-3 glow-effect_dark card__no-padding bg-color">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="CodesandboxIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                :disabled="true"
                size="large"
                class="w-full button-text__left-align button__fully-opaque bg-color"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="">
                {{ _location.selectedModule.name }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
      </div>
      <div class="vx-row" id="added-location-rows">
        <div class="vx-col w-full">
          <vx-card class="mb-3 glow-effect_dark card__no-padding bg-color">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="DiscIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                :disabled="true"
                size="large"
                class="w-full button-text__left-align button__fully-opaque bg-color"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="">
                {{ _location.selectedTopic.name }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
      </div>
    </div>

    <div class="vx-row mt-5" id="add-location-button">
      <div class="mb-3 vx-col w-3/4 sm:w-3/5 md:w-2/5 lg:w-1/4 xl:w-1/5">
        <vx-card card-background="#262d4a" class="mb-3 glow-effect_dark card__no-padding">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text school-primary_gradient glow-effect_primary">
                <span><feather-icon class="pt-1" icon="PlusCircleIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              size="large"
              class="w-full button-text__left-align input-group_prepend-slot-bg glow-effect_primary__hover"
              style="border-radius:0 7px 7px 0"
              type="filled"
              color=""
              @click="showAddLocationPopup">
              Add Location
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
      <vs-spacer></vs-spacer>
      <div class="vx-col w-3/4 xs:w-full sm:w-3/5 md:w-2/5 lg:w-2/4 xl:w-1/3">
        <vx-card class="mb-3 glow-effect_dark card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="SaveIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="locationsProp ? false : !uploadedFileUrl"
              size="large"
              class="w-full button-text__left-align glow-effect_primary school-primary_gradient"
              style="border-radius:0 7px 7px 0"
              @click="save">
              {{ locations.length > 0 ? `Save to ${locations.length + 1} Locations` : `Save to 1 Location` }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>

    <vs-popup id="add-location" ref="addlocationpopup" fullscreen title="Add Location" class="vs-con-loading__container" :active.sync="addLocationPopupActive">
      <pick-language
        :isPickLanguageActive="isPickLanguageActive"
        :languages="languages"
        @languageSelected="languageSelected"
      />

      <pick-grade
        :isPickGradeActive="isPickGradeActive"
        :selectedLanguage="selectedLanguage"
        :grades="grades"
        :gradeGroups="gradeGroups"
        @gradeSelected="gradeSelected"
        @backToPickLanguage="backToPickLanguage"
        :showComingSoon="showComingSoon"
      />

      <pick-subject
        :isPickSubjectActive="isPickSubjectActive"
        :selectedLanguage="selectedLanguage"
        :selectedGrade="selectedGrade"
        :subjects="subjects"
        @subjectSelected="subjectSelected"
        @backToPickLanguage="backToPickLanguage"
        @backToPickGrade="backToPickGrade"
        :showComingSoon="showComingSoon"
      />

      <pick-module
        :isPickModuleActive="isPickModuleActive"
        :selectedLanguage="selectedLanguage"
        :selectedGrade="selectedGrade"
        :selectedSubject="selectedSubject"
        :modules="modules"
        @moduleSelected="moduleSelected"
        @backToPickLanguage="backToPickLanguage"
        @backToPickGrade="backToPickGrade"
        @backToPickSubject="backToPickSubject"
        :showComingSoon="showComingSoon"
      />

      <pick-topic
        :isPickTopicActive="isPickTopicActive"
        :selectedLanguage="selectedLanguage"
        :selectedGrade="selectedGrade"
        :selectedSubject="selectedSubject"
        :selectedModule="selectedModule"
        :moduleData="moduleData"
        @topicSelected="topicSelected"
        @backToPickLanguage="backToPickLanguage"
        @backToPickGrade="backToPickGrade"
        @backToPickSubject="backToPickSubject"
        @backToPickModule="backToPickModule"
      />

      <preview-and-save
        :isSummaryAndSaveActive="isSummaryAndSaveActive"
        :selectedLanguage="selectedLanguage"
        :selectedGrade="selectedGrade"
        :selectedSubject="selectedSubject"
        :selectedModule="selectedModule"
        :selectedTopic="selectedTopic"
        @saveLocation="saveLocation"
        @backToPickLanguage="backToPickLanguage"
        @backToPickGrade="backToPickGrade"
        @backToPickSubject="backToPickSubject"
        @backToPickModule="backToPickModule"
        @backToPickTopic="backToPickTopic"
      />
    </vs-popup>
  </div>
</template>

<script>
import PickLanguage from "./addlocationcomponents/PickLanguage.vue";
import PickGrade from "./addlocationcomponents/PickGrade.vue";
import PickSubject from "./addlocationcomponents/PickSubject.vue";
import PickModule from "./addlocationcomponents/PickModule.vue";
import PickTopic from "./addlocationcomponents/PickTopic.vue";
import PreviewAndSave from "./addlocationcomponents/SummaryAndSave.vue";
export default {
  components: {
    PickLanguage,
    PickGrade,
    PickSubject,
    PickModule,
    PickTopic,
    PreviewAndSave
  },
  props: {
    isLocationViewActive: {
      type: Boolean,
      required: true
    },
    selectedData: {
      type: Object,
      required: false
    },
    uploadedFileUrl: {
      required: false
    },
    locationsProp: {
      required: false
    }
  },
  data() {
    return {
      isPickLanguageActive: true,
      isPickGradeActive: false,
      isPickSubjectActive: false,
      isPickModuleActive: false,
      isPickTopicActive: false,
      isSummaryAndSaveActive: false,
      addLocationPopupActive: false,
      selectedLanguage: "",
      selectedGrade: {},
      selectedSubject: {},
      selectedModule: {},
      selectedTopic: {},
      gradeGroups: [],
      grades: {},
      languages: [],
      subjects: {},
      moduleData: {},
      modules: {},
      locations: [],
      showComingSoon: false
    };
  },
  computed: {
    isLocationViewActiveLocal: {
      get() {
        return this.isLocationViewActive;
      }
    }
  },
  watch: {
    addLocationPopupActive: function(val) {
      if(!val) {
        this.backToPickLanguage();
      }
    },
    locationsProp: function(val) {
      if(val) {
        this.locations = val;
      }
    }
  },
  methods: {
    showAddLocationPopup() {
      var self = this;

      self.addLocationPopupActive = true;
      self.getLanguages();
    },
    getLanguages() {
      var self = this;

      self.showLoadingOnElement("addlocationpopup", 1, "material");

      var onSuccess = response => {
        self.languages = response.data;
      };
      var onFinally = response => {
        self.$vs.loading.close(self.$refs.addlocationpopup.$el);
      };
      
      self.$ajaxGetAnon(self, "Language/GetLanguagesOnly?siteId=" + self.$getSiteId(), onSuccess, onFinally);
    },
    getGrades() {
      var self = this;
      self.showComingSoon = false;

      self.showLoadingOnElement('addlocationpopup', 1, 'material');

      var onSuccess = response => {
        self.grades = response.data.sort((a, b) => a.name > b.name ? 1 : -1);

        self.grades.forEach(x => {
          if (!x.group) {
            x.group = "Uncategorised"
          }
        })

        var temp_groups = [];

        self.gradeGroups = [];

        temp_groups = self.grades.map(function(item) {
          return { name: item.group };
        });

        temp_groups.forEach(_group => {
          if (self.gradeGroups.filter(function(item) { return _group.name == item.name; }).length == 0 && _group.name != null)
            self.gradeGroups.push(_group);
        });

        self.gradeGroups = self.gradeGroups.sort((a, b) => a.name > b.name ? 1 : -1);

        self.showComingSoon = self.grades.length == 0 ? true : false;
      };
      var onFinally = response => {
        self.$vs.loading.close(self.$refs.addlocationpopup.$el);
      };

      self.$ajaxGetAnon(self, "CourseClassification/GetCourseClassificationsByLanguage?siteId=" + self.$getSiteId() + "&language=" + self.selectedLanguage, onSuccess, onFinally);
    },
    getSubjects() {
      var self = this;

      self.showComingSoon = false;

      var gradeId = self.selectedGrade.id;

      self.showLoadingOnElement('addlocationpopup', 1, 'material');

      var onSuccess = function(response) {
        self.subjects = response.data.sort((a, b) => a.name > b.name ? 1 : -1);
        self.showComingSoon = self.subjects.length == 0 ? true : false;
      };

      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.addlocationpopup.$el);
      };

      self.$ajaxGetAnon(self, "Course/GetCoursesByClassificationStandalone?classificationId=" + gradeId + "&siteId=" + self.$getSiteId(), onSuccess, onFinally);
    },
    getModuleData() {
      var self = this;
      self.showComingSoon = false;

      self.showLoadingOnElement('addlocationpopup', 1, 'material');

      var onSuccess = function(response) {
        self.moduleData = response.data;
        var temp_modules = [];
        self.modules = [];

        temp_modules = self.moduleData.map(function(item) {
          return {
            id: item.moduleCategoryId,
            name: item.moduleCategoryName,
            termId: item.moduleGroupId,
            hasNewContent: item.hasNewContent,
            isLibraryResource: item.libraryResourceTypeId ? true : false,
          };
        });

        temp_modules.forEach(_module => {
          if (self.modules.filter(function(item) { return _module.id == item.id; }).length == 0 && _module.id != null)
            self.modules.push(_module);
        });

        self.modules = self.modules.sort((a, b) => a.name > b.name ? 1 : -1);

        self.showComingSoon = self.modules.length == 0 ? true : false;
      };

      var onFinally = function() {
        self.$vs.loading.close(self.$refs.addlocationpopup.$el);
      };

      self.$ajaxGet(self, "Module/Admin/GetModuleData?subjectId=" + self.selectedSubject.id, onSuccess, onFinally);
    },
    languageSelected(language) {
      var self = this;
      self.selectedLanguage = language;
      self.getGrades();
      self.isPickLanguageActive = false;
      self.isPickGradeActive = true;
    },
    gradeSelected(grade) {
      var self = this;
      self.selectedGrade = grade;
      self.getSubjects();
      self.isPickGradeActive = false;
      self.isPickSubjectActive = true;
    },
    subjectSelected(subject, icon) {
      var self = this;
      self.selectedSubject = subject;
      self.selectedSubject.icon = icon;
      self.getModuleData();
      self.isPickSubjectActive = false;
      self.isPickModuleActive = true;
    },
    moduleSelected(module) {
      var self = this;
      self.selectedModule = module;
      self.isPickModuleActive = false;
      self.isPickTopicActive = true;
    },
    topicSelected(topic) {
      var self = this;
      self.selectedTopic = topic;
      self.isPickTopicActive = false;
      self.isSummaryAndSaveActive = true;
    },
    saveLocation() {
      var self = this;
      self.backToPickLanguage();
      self.addLocationPopupActive = false;
      var data = {
        selectedLanguage: self.selectedLanguage,
        selectedGrade: self.selectedGrade,
        selectedSubject: self.selectedSubject,
        selectedModule: self.selectedModule,
        selectedTopic: self.selectedTopic
      }
      self.locations.push(data);
    },
    backToPickLanguage() {
      this.grades = [];
      this.gradeGroups = [];
      this.subjects = [];
      this.modules = [];
      this.isPickGradeActive = false;
      this.isPickSubjectActive = false;
      this.isPickModuleActive = false;
      this.isPickTopicActive = false;
      this.isSummaryAndSaveActive = false;

      this.isPickLanguageActive = true;
    },
    backToPickGrade() {
      this.subjects = [];
      this.modules = [];
      this.isPickLanguageActive = false;
      this.isPickSubjectActive = false;
      this.isPickModuleActive = false;
      this.isPickTopicActive = false;
      this.isSummaryAndSaveActive = false;

      this.isPickGradeActive = true;
    },
    backToPickSubject() {
      this.modules = [];
      this.isPickLanguageActive = false;
      this.isPickGradeActive = false;
      this.isPickModuleActive = false;
      this.isPickTopicActive = false;
      this.isSummaryAndSaveActive = false;

      this.isPickSubjectActive = true;
    },
    backToPickModule() {
      this.isPickLanguageActive = false;
      this.isPickGradeActive = false;
      this.isPickSubjectActive = false;
      this.isPickTopicActive = false;
      this.isSummaryAndSaveActive = false;

      this.isPickModuleActive = true;
    },
    backToPickTopic() {
      this.isPickLanguageActive = false;
      this.isPickGradeActive = false;
      this.isPickSubjectActive = false;
      this.isPickModuleActive = false;
      this.isSummaryAndSaveActive = false;

      this.isPickTopicActive = true;
    },
    save() {
      var self = this;
      var allLocations = [];

      allLocations.push(self.selectedData.selectedTopic.id);
      
      self.locations.forEach(function(_location) {
        allLocations.push(_location.selectedTopic.id);
      });

      self.$emit("save", allLocations);
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    }
  },
};
</script>

<style lang="scss">
  #current-location-row.vx-row > .vx-col {
    padding: 0 0.7rem !important;
  }

  #added-location-rows.vx-row > .vx-col {
    padding: 0 0.7rem !important;
  }

  #add-location-button.vx-row > .vx-col {
    padding: 0 0.7rem !important;
  }

  #add-location .vs-popup {
    background: rgb(65, 71, 94) !important;
    color: rgb(202, 202, 202) !important;
    >.vs-popup--header {
      background: rgb(38, 45, 74) !important;

      > div > h3 {
        color: rgb(255, 255, 255) !important;
      }
    }

    .vs-popup--content {
      height: inherit !important;
    }
  }

  .grade-symbol {
    width: 55px !important;

    > span {
      font-size: 1.7rem !important;
    }
  }

  #removelocationbtn {
    // display: none;
    visibility: visible;
    opacity: 0.4;
    transition: visibility 0s, opacity 0.2s linear;
    font-size: 9px;
    padding: 7px;
    height: 24px;
    align-self: center;
    font-weight: 500;
  }

  .show-remove-location-on_hover:hover {
    #removelocationbtn {
      // display: inline;
      visibility: visible;
      opacity: 1;
      font-size: 9px;
      padding: 7px;
      height: 24px;
      align-self: center;
      font-weight: 500;
    }
  }
</style>
No newline at end of file
